export class DateUtilities {
  static getGenDateString() {
    const genDate = new Date()
      .toISOString()
      .replace(/[-:]/g, "")
      .replace("T", "_")
      .replace("Z", "")
      .split(".")[0];
    return genDate;
  }

  static getDayOfYear(stringDate) {
    let date = new Date(stringDate);
    let start = new Date(date.getFullYear(), 0, 1);
    let diff = date - start;
    let oneDay = 1000 * 60 * 60 * 24;
    let dayOfYear = Math.floor(diff / oneDay);

    return dayOfYear;
  }

  static getYearFraction(stringDate) {
    let dayOfYearNumber = DateUtilities.getDayOfYear(stringDate);
    let date = new Date(stringDate);
    let start = new Date(date.getFullYear(), 0, 1);
    let end = new Date(date.getFullYear(), 11, 31);
    let diff = end - start;
    let oneDay = 1000 * 60 * 60 * 24;
    let daysInYear = Math.floor(diff / oneDay);

    let yearFraction = dayOfYearNumber / daysInYear;

    return yearFraction;
  }

  static getYearFractionActual(stringDate) {
    let date = new Date(stringDate);
    let start = new Date(date.getFullYear(), 0, 1);
    let diff = date - start;
    let oneDay = 1000 * 60 * 60 * 24;
    let daysInYear = diff / oneDay;

    let yearFraction = daysInYear / 365.25;

    return yearFraction;
  }

  static isLeapYear(year) {
    // Un anno è bisestile se è divisibile per 4
    // ma non è divisibile per 100, a meno che non sia divisibile per 400.
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  static getYearFraction30_360(stringDate) {
    let startDate = new Date(stringDate);

    let daysStartDate = startDate.getDate();
    let monthStartDate = startDate.getMonth() + 1; // Mesi in JavaScript sono zero-based
    let yearStartDate = startDate.getFullYear();

    let endDate = new Date(yearStartDate, 11, 31);

    let daysEndDate = endDate.getDate();
    let monthsEndDate = endDate.getMonth() + 1;
    let yearEndDate = endDate.getFullYear();

    // Calcola i giorni nel mese considerando sempre 30 giorni
    let daysInMonthStartDate = Math.min(30, daysStartDate);
    if (monthStartDate == 2) {
      if (DateUtilities.isLeapYear(yearStartDate) && daysStartDate == 29) {
        daysInMonthStartDate = 30;
      } else if (
        !DateUtilities.isLeapYear(yearStartDate) &&
        daysStartDate == 28
      ) {
        daysInMonthStartDate = 30;
      }
    }
    let daysInMonthEndDate = Math.min(30, daysEndDate);

    // Calcola la frazione dell'anno
    let complementaryYearFraction =
      yearEndDate -
      yearStartDate +
      (monthsEndDate - monthStartDate) / 12 +
      (daysInMonthEndDate - (daysInMonthStartDate - 1)) / 360;
    let yearFraction = 1 - complementaryYearFraction;

    return yearFraction;
  }

  static getRangeYearFraction30_360(stringDate1, stringDate2) {
    let date1 = new Date(stringDate1);
    let date2 = new Date(stringDate2);
    let startDate = date1 < date2 ? date1 : date2;
    let endDate = date1 < date2 ? date2 : date1;
    let nYears = endDate.getFullYear() - startDate.getFullYear() - 1;

    return (
      nYears +
      (1 - DateUtilities.getYearFraction30_360(startDate.toISOString())) +
      DateUtilities.getYearFraction30_360(endDate.toISOString())
    );
  }

  static getRangeYearFractionActual(stringDate1, stringDate2) {
    let date1 = new Date(stringDate1);
    let date2 = new Date(stringDate2);
    let startDate = date1 < date2 ? date1 : date2;
    let endDate = date1 < date2 ? date2 : date1;
    let nYears = endDate.getFullYear() - startDate.getFullYear() - 1;

    return (
      nYears +
      (1 - DateUtilities.getYearFraction(startDate.toISOString())) +
      DateUtilities.getYearFraction(endDate.toISOString())
    );
  }

  static getIsoDateString(dateStr) {
    if (!dateStr) return null;
    return dateStr.split("T")[0];
  }
}
